import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router';

import './Navbar.css';
import Icon from '../icon/Icon';

const Navbar = () => {
    // const location = useLocation();
    // let isHomePage = false;

    // if (location.pathname === '/') {
    //     isHomePage = true;
    // }

    return (
        <nav
        // style={
        //     {
        //         boxShadow:
        //         	location.pathname === '/' ? '' : '0 2px 8px hsla(150, 0%, 2%, 100%)',
        //     }
        // }
        >
            <NavLink
                to='/'
                className='Navbar__Company'
            >
                <Icon />

                <div className='Navbar__CompanyName'>Visomec</div>
            </NavLink>
            <input
                type='checkbox'
                id='Navbar__MenuToggle'
                className='Navbar__MenuToggle'
                hidden
            ></input>
            <ul>
                <li>
                    <NavLink
                        to='/'
                        className={({ isActive }) =>
                            isActive
                                ? 'Navbar__PageLink Navbar__CurrentPage'
                                : 'Navbar__PageLink'
                        }
                    >
                        HOME
                    </NavLink>
                </li>
                {/* <li>
					<NavLink
						to="/about"
						className={({ isActive }) =>
							isActive
								? 'Navbar__MainPageLink Navbar__CurrentPage'
								: 'Navbar__MainPageLink'
						}
					>
						About
					</NavLink>
				</li> */}
                <li className={'Navbar__ProjectTab'}>
                    <a
                        className={'Navbar__PageLink'}
                        // style={{ color: '#ccc' }}
                    >
                        PROJECTS
                    </a>
                    <ul>
                        <li>
                            <NavLink
                                to='/lightpollutionmap'
                                className={({ isActive }) =>
                                    isActive
                                        ? 'Navbar__PageLink Navbar__CurrentPage'
                                        : 'Navbar__PageLink'
                                }
                            >
                                Light Pollution Map
                            </NavLink>
                        </li>
                        <li>
                            {/* <NavLink
                                to='/modelviewer'
                                className={({ isActive }) =>
                                    isActive
                                        ? 'Navbar__PageLink Navbar__CurrentPage'
                                        : 'Navbar__PageLink'
                                }
                            >
                                Model Viewer
                            </NavLink> */}
                        </li>
                    </ul>
                </li>
                {/* <li>
					<NavLink
						to="/contact"
						className={({ isActive }) =>
							isActive
								? 'Navbar__MainPageLink Navbar__CurrentPage'
								: 'Navbar__MainPageLink'
						}
					>
						Contact
					</NavLink>
				</li> */}
            </ul>

            <label
                htmlFor='Navbar__MenuToggle'
                className='Navbar__MenuToggleLabel'
            >
                <div
                    className='Navbar__Menu'
                    type='checkbox'
                >
                    <div className='Navbar__MenuTop'></div>
                    <div className='Navbar__MenuMid'></div>
                    <div className='Navbar__MenuBottom'></div>
                </div>
            </label>
        </nav>
    );
};

export default Navbar;
